import React from 'react';
import { faCheck, faHandshake } from '@fortawesome/pro-light-svg-icons';
import { IAction } from './interfaces';
import { ConfirmCompleteAppointmentsDialog } from '../modals/complete-appointment/confirm-complete-appointments-dialog';
import { AssignCaseworkerAppointmentDialog } from '../modals/assign-caseworker/assign-caseworker-appointment-dialog';

export const actions: IAction[] = [
  {
    context: 'appointments',
    id: 'CompanyCompleteAppointment',
    displayName: 'Afslut virksomhedsaftaler',
    action: selectedEntries => <ConfirmCompleteAppointmentsDialog appointmentIds={selectedEntries} />,
    isVisible: selectedItemsCount => selectedItemsCount > 0,
    isDisabled: selectedItemsCount => (selectedItemsCount > 500 ? 'Antallet af valgte elementer må ikke overstige 500' : ''),
    icon: faCheck,
  },
  {
    context: 'appointments',
    id: 'CompanyAppointmentAssignTeamOrUser',
    displayName: 'Tildel sagsbehandler til virksomhedsaftaler',
    action: selectedEntries => <AssignCaseworkerAppointmentDialog appointmentIds={selectedEntries} />,
    isVisible: selectedItemsCount => selectedItemsCount > 0,
    isDisabled: selectedItemsCount => (selectedItemsCount > 500 ? 'Antallet af valgte elementer må ikke overstige 500' : ''),
    icon: faHandshake,
  },
];
